import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import PopupModal from "../components/popup-modal.svelte";
import { gettingStartedSlider } from "./blocks";
import HomeTestimonials from '../components/home-testimonials.svelte'

import { animateHero } from "./home";

import {
  partnerSlider,
  partnershipStates,
  storiesSlider,
  cardsGrid,
  featuredPostsSlider,
  postSlider,
  testimonialSlider,
  blogAnimate,
  textCardsBlock,
  helpfulArticles,
} from "./blocks";



const { $ } = window;

const $body = $(document.body);

function sessionStorageUTM() {
  let url = new URL(window.location.href);
  let params = new URLSearchParams(url.search);
  for (let item of url.search.replace("?", "").split("&")) {
    let [key, val] = item.split("=");
    if (params.get(key)) {
      sessionStorage.setItem(key, val);
    }
  }
}

export default {
  init() {
    gsap.registerPlugin(ScrollTrigger);
    // intObserve()

    sessionStorageUTM();
    mobileMenu();
    testimonialSlider(); //implicit animate
    textCardsBlock();
    helpfulArticles();
    partnerSlider();
    storiesSlider();
    cardsGrid();
    partnershipStates();
    // animateTextCardRotator() //for-subs

   let $testimonialsWrap = $('#home-testimonials-wrap')
   if( $testimonialsWrap.length ) {
      new HomeTestimonials({
         target: $testimonialsWrap[0],
         // props: $testimonialsWrap.data()
      })
   }

    if (
      $body.hasClass("sub-success-blog") ||
      $body.hasClass("case-study") ||
      $body.hasClass("news-press") ||
      $body.hasClass("school-insights")
    ) {
      featuredPostsSlider();
      if (window.innerWidth < 767) {
        postSlider();
      }
    }

    getStartedGrid();

    $(".wp-block-media-text img").each((idx, el) => {
      let str = `--translateY${idx}`;
      const instance = basicScroll.create({
        elem: el,
        from: "top-bottom",
        to: "middle-top",
        props: {
          [str]: {
            from: "20%",
            to: "-10%",
          },
        },
      });

      instance.start();
    });


    function _animateShow() {
      // setTimeout(() => $body.addClass('mm-open'), 200)
      const tl = gsap.timeline({});
      var textWrapper = document.querySelector(".modal h2");
      textWrapper.innerHTML = textWrapper.textContent.replace(
        /\S+/g,
        "<span class='word'>$&</span>"
      );
      gsap.set(".modal h2 .word", { opacity: 0, y: 24, x: 0, rotateZ: 0 });
      gsap.set(".modal h2 ~ *", { opacity: 0, y: 24 });
      tl.to(".modal h2 .word", {
        delay: 0.2,
        duration: 0.5,
        ease: "elastic.out(1,0.5)",
        opacity: 1,
        rotateZ: 0,
        stagger: 0.075,
        x: 0,
        y: 0,
      }).to(
        ".modal h2 ~ *",
        {
          duration: 0.3,
          ease: "power1.out",
          opacity: 1,
          y: 0,
        },
        "-=0.5"
      );
    }
    $("a#newsletter-btn").click((e) => {
      _animateShow();
    });

    gettingStartedSlider();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // class to hide outlines if not using keyboard
    $body.on("mousedown", function () {
      $body.addClass("using-mouse");
    });
    $body.on("keydown", function () {
      $body.removeClass("using-mouse");
    });

    function animateShow() {
      const tl = gsap.timeline({});
      var textWrapper = document.querySelector(".modal h2");
      gsap.set(".modal h2", { opacity: 0, y: 24, x: 0, rotateZ: 0 });
      gsap.set(".modal h2 ~ *:not(.btns-wrap)", { opacity: 0, y: 24 });
      gsap.set(".modal .btn", { opacity: 0, y: 12 });
      tl.to(".modal h2", {
        delay: 0.2,
        duration: 0.5,
        ease: "power1.out",
        opacity: 1,
        rotateZ: 0,
        stagger: 0.075,
        x: 0,
        y: 0,
      }).to(
        ".modal h2 ~ *:not(.btns-wrap)",
        {
          duration: 0.3,
          ease: "power1.out",
          opacity: 1,
          stagger: 0.1,
          y: 0,
        },
        "-=0.45"
      ).to(
        ".modal .btn",
        {
          duration: 0.3,
          ease: "power1.out",
          opacity: 1,
          stagger: 0.1,
          y: 0,
        },
        "-=0.6"
      );

    }

    //for each add an on click event to show the modal and inject the content
    for( let modal of siteModals ) {
      new PopupModal({
        target: document.body,
        props: {
          modal: modal,
        }, //footer.php
      });

      const $trigger = $(`a[href="${modal.id}"]`)
      $trigger.attr("data-lity", "");
      $trigger.click(() => animateShow());
    }



    //  setTimeout(function () {
    var interval = setInterval(function () {
      if ($body.hasClass("page-id-120")) {
        if (!$(".job-county-card").length) {
          return;
        }
      }
      clearInterval(interval);

      let sessionParameters = "?";
      Object.keys(sessionStorage).map((key) => {
        //if(key != 'wp-api-schema-model') {
        if (key.includes("utm_")) {
          //} != 'wp-api-schema-model') {
          sessionParameters += key + "=" + sessionStorage.getItem(key) + "&";
        }
      });

      let currentURL = new URL(window.location.href);
      $("a:not([data-lity])").each((_idx, a) => {
        if( !a.href || typeof a.href == 'object' ) {
          return;
        }
        const url = new URL(a.href);
        // console.log(currentURL.origin)
        if (url.origin.includes(".swingeducation.com")) {
          //} !== currentURL.origin) { //sub.swingeducation.com
          // console.info(url)
          a.href += sessionParameters;
          //remove last '&'
          a.href = a.href.slice(0, a.href.length - 1);
        }
      });
    }, 20);
  },
};

function animate() {
  animateHero();

  //partner with us / whitepaper
  animateWhitepaperForm();
  blogAnimate();
  animateWPMediaText();
  animateWPButtonLink();

  animateError404();
  animateCTA();
  animateFooter();
}

function mobileMenu() {
  let $mobileMenu = $("#mobile-menu");
  $mobileMenu.removeClass("loading");
  $("#mobile-menu .menu-item-has-children").find(".sub-menu").hide();
  let showing = false;
  $("#toggle_nav").on("click", () => {
    $mobileMenu.slideToggle(350);
    setTimeout(() => $("html").toggleClass("mm-open"), 200);
  });
  let current,
    t,
    duration = 250;
  $("#mobile-menu .menu-item-has-children > *:first-child").click((e) => {
    e.preventDefault();
    if (t) {
      return;
    }

    e.target.classList.toggle("menu-open");
    $(e.target).parent().toggleClass("menu-open");

    //hide previous
    if (current) {
      //open menu
      if (!current.includes(e.target.innerText)) {
        //different from open
        $("#mobile-menu .menu-item-has-children > *:first-child")
          .parent()
          .find(".sub-menu")
          .slideUp(duration);
        $("#mobile-menu .menu-item-has-children > *:first-child").removeClass(
          "menu-open"
        );
        current = e.target.innerText;
        //show respective
        setTimeout(() => {
          $(e.target).parent().find(".sub-menu").slideToggle(duration);
        }, duration - 100);
      } else {
        //closing open menu
        $(e.target).parent().find(".sub-menu").slideToggle(duration);
        $(e.target).removeClass("menu-open");
        current = null;
      }
    } else {
      //no open menu
      $(e.target).parent().find(".sub-menu").slideToggle(duration);
      current = e.target.innerText;
    }

    // space out events
    t = setTimeout(() => {
      t = null;
    }, 100);
  });
  let x = window.matchMedia("(max-width: 1200px)"); //match __header.scss
  toggleMenu(x);
  x.addListener(toggleMenu);
  function toggleMenu(x) {
    if (!x.matches) {
      //desktop
      $mobileMenu.show();
      $("#mobile-menu .menu-item-has-children > *:first-child")
        .parent()
        .find(".sub-menu")
        .show();
      $("html").removeClass("mm-open");
    } else {
      $mobileMenu.hide();
      $("#mobile-menu .menu-item-has-children > *:first-child")
        .parent()
        .find(".sub-menu")
        .slideUp(duration);
    }
  }
}

function _detectswipe(el, func) {
  let swipe_det = new Object();
  swipe_det.sX = 0;
  swipe_det.sY = 0;
  swipe_det.eX = 0;
  swipe_det.eY = 0;
  // var min_x = 20;  //min x swipe for horizontal swipe
  var max_x = 40; //max x difference for vertical swipe
  var min_y = 70; //min y swipe for vertical swipe
  // var max_y = 2000;  //max y difference for horizontal swipe
  var direc = "";
  let ele = document.getElementById(el);
  ele.addEventListener(
    "touchstart",
    function (e) {
      var t = e.touches[0];
      swipe_det.sX = t.screenX;
      swipe_det.sY = t.screenY;
    },
    false
  );
  ele.addEventListener(
    "touchmove",
    function (e) {
      e.preventDefault();
      var t = e.touches[0];
      swipe_det.eX = t.screenX;
      swipe_det.eY = t.screenY;
    },
    false
  );
  ele.addEventListener(
    "touchend",
    function (e) {
      //horizontal detection
      //   if ((((swipe_det.eX - min_x > swipe_det.sX) || (swipe_det.eX + min_x < swipe_det.sX)) && ((swipe_det.eY < swipe_det.sY + max_y) && (swipe_det.sY > swipe_det.eY - max_y)))) {
      //     if(swipe_det.eX > swipe_det.sX) direc = "r";
      //     else direc = "l";
      //   }
      //vertical detection
      if (
        (swipe_det.eY - min_y > swipe_det.sY ||
          swipe_det.eY + min_y < swipe_det.sY) &&
        swipe_det.eX < swipe_det.sX + max_x &&
        swipe_det.sX > swipe_det.eX - max_x
      ) {
        if (swipe_det.eY < swipe_det.sY) {
          $("html").removeClass("mm-open");
          $("#mobile-menu").slideToggle(350);
        }
      }

      if (direc != "") {
        if (typeof func == "function") func(el, direc);
      }
      direc = "";
    },
    false
  );
}

function getStartedGrid() {
  let is_home = document.body.classList.contains('page-template-front-page');
  let $gsGrid = $("#get-started-grid");
  if ($gsGrid.length) {
    const wrap = document.querySelector(".gs-results-wrap");
    const results = document.querySelector(".no-locations--text");
    const perPage = 6;
    let all_cards  = $('.job-county-card');
    let home_cards = $('.job-county-card:not(.job-county-card-is-city)');
    let city_cards = $('.job-county-card-is-city');
    let $cards = is_home ? home_cards : $('.job-county-card');
    let $filtered = $cards;
    let pageIdx = 0;
    let t;
    
    // init
    results.style.display = "none";
    $cards.hide();
    $cards.slice(0, perPage).fadeIn();
    $(".gs-pagination").text("");
    renderButtons();
    
    /**
     * Homepage
     */
    if (is_home) {
      $(city_cards).hide()
      $("#state-city-search").keyup(function() {
        //reset
        $(".gs-pagination").text("");
        results.style.display = "none";
        $cards.hide();

        clearTimeout(t);
        t = setTimeout(() => {
          pageIdx = 0;

          if (0 == $(this).val().length) {
            $cards = home_cards;
            $(city_cards).hide();
            $cards.slice(0, perPage).fadeIn();
            $filtered = $cards;
            // return;
          } else {
            $cards = all_cards;
            var val = $.trim($(this).val()).replace(/ +/g, " ").toLowerCase();
            $filtered = $cards.filter(function () {
              var text = $(this)
                .find("h3")
                .text()
                .replace(/\s+/g, " ")
                .toLowerCase();
              return text.indexOf(val) > -1;
            });
            if ($filtered.length == 0) {
              results.style.display = "block";
            } else {
              $filtered.slice(pageIdx * perPage, (pageIdx + 1) * perPage).fadeIn();
              $cards = $filtered;
            }
          }

          renderButtons();
        }, 200);
      })
    } else {
      /**
       * Non homepage
       */
      $("#state-city-search").keyup(function () {
      
        //reset
        $(".gs-pagination").text("");
        results.style.display = "none";
        $cards.hide();
  
        clearTimeout(t);
        t = setTimeout(() => {
          pageIdx = 0;
  
          if (0 == $(this).val().length) {
            $cards.slice(0, perPage).fadeIn();
            $filtered = $cards;
            // return;
          } else {
            var val = $.trim($(this).val()).replace(/ +/g, " ").toLowerCase();
  
            $filtered = $cards.filter(function () {
              var text = $(this)
                .find("h3")
                .text()
                .replace(/\s+/g, " ")
                .toLowerCase();
              return text.indexOf(val) > -1;
            });
            if ($filtered.length == 0) {
              results.style.display = "block";
            } else {
              $filtered.slice(pageIdx * perPage, (pageIdx + 1) * perPage).fadeIn();
            }
          }
  
          renderButtons();
        }, 200);
      });
    }

    function renderButtons() {
      $(".gs-pagination").text("");
      for (let i in Array.from(Array(Math.ceil($filtered.length / perPage)).keys())) {
        const btn = document.createElement("button");
        btn.innerText = parseInt(i) + 1;
        btn.addEventListener("click", (e) => {
          pageIdx = parseInt(i);
          $("button.page-active").removeClass("page-active");
          e.target.classList.add("page-active");
          $cards.hide();
          $cards.slice(pageIdx * perPage, (pageIdx + 1) * perPage).fadeIn();
        });
        if (i == 0) {
          btn.classList.add("page-active");
        }
        $(".gs-pagination").append(btn);
      }
    }

  }
}
